import React from "react";
import "../../css/Sidebar.css";
import { useNavigate, useLocation } from "react-router-dom";

const Row = ({ active, onClick, children }) => (
    <button
        onClick={onClick}
        className={[
            "w-full",
            "text-left",
            "text-sm",
            "font-semibold",
            "rounded-xl",
            "transition-colors",
            "px-4 py-3",
            "flex items-center gap-3", // FLEX: icon + label
            "hover:bg-[#616161]",
            active ? "bg-[#616161]" : "",
        ].join(" ")}
    >
        {children}
    </button>
);

const ImgIcon = ({ src, alt }) => (
    <img
        src={src}
        alt={alt}
        className="h-6 w-6 shrink-0 opacity-100 pointer-events-none"
    />
);

const Sidebar = ({ isOpen, setIsOpen }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (path) => {
        navigate(path);
        // Close sidebar on mobile after navigation
        if (window.innerWidth < 1024) {
            setIsOpen(false);
        }
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <>
            {/* Mobile Overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0  bg-opacity-50 z-40 lg:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}

            <div
                className={`sidebar h-screen w-56 text-white transition-all duration-300 fixed lg:relative z-50 overflow-y-auto py-4 ${isOpen ? "translate-x-0" : "-translate-x-full"
                    } lg:translate-x-0`}
                style={{
                    backgroundColor: "#1F1E1E",
                    borderRadius: "24px",
                    zIndex: 9998,
                    top: 0,
                    left: 0,
                    height: "100vh"
                }}
            >
                <div className="flex items-center justify-center h-16 px-4 mb-4">
                    {/* Logo */}
                    <img
                        src="/assets/Transparent background.png"
                        alt="Ducktail Logo"
                        onClick={() => handleNavigation("/")}
                        className="h-12 pr-4 cursor-pointer"
                    />
                </div>

                {/* Navigation links */}
                <nav className="mt-2 space-y-2">
                    {/* 1. Project Invite */}
                    <Row
                        active={isActive("/agent/real-estate")}
                        onClick={() => handleNavigation("/agent/real-estate")}
                    >
                        <ImgIcon src="/sidebaricons/project invite 1.png" alt="Real Estate" />
                        <span>Real Estate</span>
                    </Row>


                    {/* 5. Profile */}
                    <Row
                        active={isActive("/agent/profile")}
                        onClick={() => handleNavigation("/agent/profile")}
                    >
                        <ImgIcon src="/sidebaricons/project invite 1.png" alt="Profile" />
                        <span>Profile</span>
                    </Row>
                </nav>
            </div>
        </>
    );
};

export default Sidebar;
